import { useTranslation } from "react-i18next";
import {
	Breadcrumb,
	Form,
	Layout,
	Tabs,
	TabsProps
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { routesConfig } from "../../../config/routes";
import { getCourseName } from "../../../service/courses";
import { CourseManagementStore } from "../../../stores/stores";
import DiscussionCourse from "./discussion-course/DiscussionCourse";
import ReviewCourse from "./review-course/ReviewCourse";
import "./ReviewAndDiscussion.scss";

type Props = {
};

const ReviewAndDiscussion = (props: Props) => {
  const { t } = useTranslation();
	const { showFilter, setShowFilter, setCourseName } = CourseManagementStore()
	const { courseId } = useParams();

	const [tab, setTab] = useState("1");
	const navigate = useNavigate();
	const [form] = Form.useForm();
	const [detailData, setDetailData] = useState<any>(null);

	const itemsTab: TabsProps["items"] = [
		{
			key: "1",
			label: <div>{t("Đánh giá khoá học", "Đánh giá khoá học")}</div>,
			children: (
				<ReviewCourse />
			),
		},
		{
			key: "2",
			label: <div>{t("Thảo luận", "Thảo luận")}</div>,
			children: (
				<div className="assigned">
					<DiscussionCourse />
				</div>
			),
		},
	];

	const onChange = (key: string) => {
		setTab(key);
		form.resetFields();
	};

	useEffect(() => {
		const getDetailCourseData = async () => {
			try {
				await getCourseName(Number(courseId)).then((res) => {
					const { data } = res.data;
					setDetailData(data);
					setCourseName(data.name)
				});
			} catch (error) {

			}
		};
		getDetailCourseData();
	}, [courseId]);

	return (
		<div className="review-and-discussion">
			<Layout className="page-header-group course-student-list">
				<Form.Provider>
					<div
						className="header"
					>
						<div className="table-header--wrapper justify-between pb-2">
							<Breadcrumb
								items={[
									{
										title: <div
											className="pointer"
											onClick={() => navigate(`${routesConfig.courseManagement}/${routesConfig.courseList}`)}>{t("Danh sách khoá học", "Danh sách khoá học")}</div>,
									},
									{
										title: detailData?.name,
									},
								]}
							/>
						</div>

					</div>
					<div className="hr-tag-m0"></div>
					<div className="tabs-heading">
						<div className="course-student-list">
							<Tabs items={itemsTab} activeKey={tab} onChange={onChange}
							/>
						</div>
					</div>
				</Form.Provider>
			</Layout>
		</div>
	);
};

export default ReviewAndDiscussion;
